export class ConfirmDialogConfig {
    title?: string = "Conferma";
    message?: string = "Confermi?";

    constructor(params: any) {
        Object.assign(this, params);
    }
}